import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { AR_REPORTS_API } from "./apiRoutes";

interface UseGetARPropertyByIdReportProps {
  communityId: string;
  propertyId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getARPropertyByIdReport = async (
  communityId: string,
  propertyId: string
) =>
  await axiosAuth.get(`${AR_REPORTS_API(communityId)}/property/${propertyId}`);

const useGetARPropertyByIdReport = ({
  communityId,
  propertyId,
  queryParams,
}: UseGetARPropertyByIdReportProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["ar-360-reports-property", communityId, propertyId],
    queryFn: () => getARPropertyByIdReport(communityId, propertyId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
    enabled: !!communityId && !!propertyId && (queryParams?.enabled ?? true),
  });
};

export default useGetARPropertyByIdReport;
